__turbopack_context__.v({
  "chart": "RoundPerformance-module__5VFkhG__chart",
  "chartContainer": "RoundPerformance-module__5VFkhG__chartContainer",
  "chartHeader": "RoundPerformance-module__5VFkhG__chartHeader",
  "roundInfoContainer": "RoundPerformance-module__5VFkhG__roundInfoContainer",
  "roundPerformance": "RoundPerformance-module__5VFkhG__roundPerformance",
  "title": "RoundPerformance-module__5VFkhG__title",
});
